import { useRecoilValue } from "recoil";
import {
  WalletPubHeaderButton,
  WalletPubHeaderButtonWrapper,
  WalletPubHeaderText,
  WalletPubHeaderUser,
  WalletPubHeaderValue,
  WalletPubHeaderWarpper,
} from "./style";
import WalletPubHeaderSkeleton from "./skeleton";
import { userState } from "../../../../../../../recoil/auth";
import { useWalletContext } from "../../../../hooks/wallet-context";
import { WalletLogTab, WalletTab } from "../../../../hooks/use-wallet-tab";

const WalletPubHeader = () => {
  const user = useRecoilValue(userState);
  const {
    setLogTab,
    setWalletTab,
    seed,
    walletLoading,
    setIsFranchisePubOpen,
  } = useWalletContext();

  const handleLogsPage = () => {
    setLogTab(WalletLogTab.SEED);
    setWalletTab(WalletTab.LOGS);
  };

  const handleFranchisePub = () => {
    setIsFranchisePubOpen(true);
    setWalletTab(WalletTab.WALLET);
  };

  if (walletLoading) return <WalletPubHeaderSkeleton />;

  return (
    <WalletPubHeaderWarpper>
      <WalletPubHeaderText>
        <WalletPubHeaderUser>
          <div className="text">
            <span>{user?.nickname}</span>님의 통합 크레딧
          </div>
          <WalletPubHeaderValue>
            {seed ? seed?.toLocaleString() : 0} RABBIT
          </WalletPubHeaderValue>
        </WalletPubHeaderUser>
      </WalletPubHeaderText>

      <WalletPubHeaderButtonWrapper>
        <WalletPubHeaderButton onClick={handleLogsPage}>
          상세내역
        </WalletPubHeaderButton>
        <WalletPubHeaderButton onClick={handleFranchisePub}>
          음료/주류 주문하기
        </WalletPubHeaderButton>
      </WalletPubHeaderButtonWrapper>
    </WalletPubHeaderWarpper>
  );
};

export default WalletPubHeader;
